module.exports = __webpack_public_path__ + "static/media/mobile-promos-banner_1.44c3497e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promos-banner/mobile-promos-banner_1.jpg
// module id = 2449
// module chunks = 7